
  import React from "react"
  import Component from "/vercel/path0/src/layouts/index.js"
  import data from "/vercel/path0/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js